<div id="layout" class="f_col notice_view">
  <app-view-title [bgImage]="api.env.theme.header_background">
    <div class="flex gap_10 f_align_c">
      {{(currentNotice ? 'notice.'+currentNotice : 'notice.title') | translate}}
    </div>
  </app-view-title>
  <div class="scroll_wrapper">
    <div class="resp_wrapper">
      <div class="resp_c-50 mt_10">
        <app-paragraph textAlign="center" class="mt_10">{{(currentNotice ? 'notice.desc.'+currentNotice : 'notice.desc') | translate}}</app-paragraph>
      </div>
    </div>
    <div class="resp_wrapper mb_40">
      <div *ngIf="currentNotice && form" [ngClass]="columnTwoFields.length ? 'fullWidth mt_10' : 'resp_c-50 mt_30'">
        <div [class.col_2]="columnTwoFields.length">
          <form id="form" [formGroup]="form" (ngSubmit)="submit()"
                [ngClass]="columnTwoFields.length ? 'flex f_center fullWidth gap_10 mt_20' : 'f_col gap_25 mb_20'">
            <div class="f_col fullWidth gap_25 mb_20">
              <ng-container *ngFor="let field of columnOneFields">
                <ng-container *ngTemplateOutlet="noticeField; context: {$implicit: field}"></ng-container>
              </ng-container>
              <app-errors-list [dark]="true" *ngIf="submitted" [formErrors]="forms.getFormErrors(form)"></app-errors-list>
            </div>
            <div *ngIf="columnTwoFields.length" class="f_col fullWidth gap_25">
              <ng-container *ngFor="let field of columnTwoFields">
                <ng-container *ngTemplateOutlet="noticeField; context: {$implicit: field}"></ng-container>
              </ng-container>
            </div>
          </form>
        </div>
        <div [ngClass]="(columnTwoFields.length ? 'resp_c-50 mt_20 ' : '') + 'mb_40 flex gap_10'">
          <app-button size="xsm" color="transparent" border="true" class="fullWidth"
                      (btnClicked)="goBack()"
                      [shortcut]="$any(currentNotice === ConsumePaymentNoticeType.REPORTING ? ShortcutAction.ESCAPE : null)"
                      [shortcutStyle]="{bottom: '-25px'}">
            {{ 'global.back' | translate }}
          </app-button>
          <app-button size="xsm" type="submit" formId="form" class="fullWidth"
                      [shortcut]="$any(currentNotice === ConsumePaymentNoticeType.REPORTING ? ShortcutAction.ENTER : null)"
                      [shortcutStyle]="{bottom: '-25px'}">
            {{ 'global.nextPrint' | translate }}
          </app-button>
        </div>
      </div>
      <ng-template #noticeField let-field>
        <ng-container *ngIf="isFieldVisible(field)">
          <app-date-range *ngIf="field.type === 'dateRange'"
                          [formCtrlNameFrom]="field.name + 'From'" [formCtrlNameTo]="field.name + 'To'"
                          type="datetime-local" [formGrp]="form"
                          [minFrom]="$any(validatorDates.minDate)" [minTo]="$any(validatorDates.minDate)"
                          [maxFrom]="$any(validatorDates.maxDate)" [maxTo]="$any(validatorDates.maxDate)"
                          [autoMinMax]="false"></app-date-range>
          <ng-container *ngIf="field.type === 'checkbox' && field.enum">
            <app-checkbox-element *ngFor="let doc of field.enum"
                                  [formGrp]="form"
                                  [formCtrlName]="doc"
                                  [text]="doc | translate"
                                  (onChange)="checkIfFormControl($event, doc)"></app-checkbox-element>
          </ng-container>
          <app-input *ngIf="field.type !== 'dateRange' && !(field.type === 'checkbox' && field.enum)"
                     [type]="field.type"
                     [formCtrlName]="field.name"
                     [formGrp]="form"
                     [label]="field.label || field.name"
                     [icon]="field.icon"
                     [id]="field.name"
                     [selectOptions]="field.enum"
                     [maxLength]="field.maxLength"
                     [textareaRows]="field.textareaRows"
                     [autoMinMaxDate]="!!(field.dateValidators?.minDate || field.dateValidators?.maxDate)"
                     [minDate]="field.dateValidators?.minDate"
                     [maxDate]="field.dateValidators?.maxDate"
                     (output)="onFieldOutput(field, $event)"></app-input>
        </ng-container>
      </ng-template>
    </div>
    <div class="parent-container mt_20 mb_40" *ngIf="!currentNotice">
      <div class="flex flex_col f_center gap_10 f_wrap">
        <app-big-button
          image="assets/images/error.png"
          [label]="'notice.RESTRICTION' | translate"
          [description]="'notice.RESTRICTION.desc' | translate"
          [responsive]="true"
          (clicked)="selectNotice(ConsumePaymentNoticeType.RESTRICTION)">
        </app-big-button>
        <app-big-button
          image="assets/images/time.png"
          [label]="'notice.REPORTING' | translate"
          [description]="'notice.REPORTING.desc' | translate"
          [responsive]="true"
          (clicked)="selectNotice(ConsumePaymentNoticeType.REPORTING)">
        </app-big-button>
      </div>
      <div class="resp_wrapper">
        <div class="resp_c-50">
          <div class="resp_minSize_l mt_40 mb_40 flex gap_10 resp_c-50">
            <app-button size="xsm" color="transparent" border="true" class="fullWidth"
                        (btnClicked)="goBack()">
              {{'global.back' | translate}}
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class=" mb_20 resp_maxSize_l">
    <div class="f_align_end">
      <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
      <app-back-btn [navTo]="{route: 'admin-request-select/'+requestId}"></app-back-btn>
    </div>
  </div>
</div>
